export enum Text {
  /**
   * Goods item description
   */
  GoodsItemDescription = "AAA",
  /**
   * Payment term
   */
  PaymentTerm = "AAB",
  /**
   * Dangerous goods additional information
   */
  DangerousGoodsAdditionalInformation = "AAC",
  /**
   * Dangerous goods technical name
   */
  DangerousGoodsTechnicalName = "AAD",
  /**
   * Acknowledgement description
   */
  AcknowledgementDescription = "AAE",
  /**
   * Rate additional information
   */
  RateAdditionalInformation = "AAF",
  /**
   * Party instructions
   */
  PartyInstructions = "AAG",
  /**
   * General information
   */
  GeneralInformation = "AAI",
  /**
   * Additional conditions of sale/purchase
   */
  AdditionalConditionsSalePurchase = "AAJ",
  /**
   * Price conditions
   */
  PriceConditions = "AAK",
  /**
   * Goods dimensions in characters
   */
  GoodsDimensionsInCharacters = "AAL",
  /**
   * Equipment re-usage restrictions
   */
  EquipmentReUsageRestrictions = "AAM",
  /**
   * Handling restriction
   */
  HandlingRestriction = "AAN",
  /**
   * Error description (free text)
   */
  ErrorDescriptionFreeText = "AAO",
  /**
   * Response (free text)
   */
  ResponseFreeText = "AAP",
  /**
   * Package content's description
   */
  PackageContentsDescription = "AAQ",
  /**
   * Terms of delivery
   */
  TermsDelivery = "AAR",
  /**
   * Bill of lading remarks
   */
  BillLadingRemarks = "AAS",
  /**
   * Mode of settlement information
   */
  ModeSettlementInformation = "AAT",
  /**
   * Consignment invoice information
   */
  ConsignmentInvoiceInformation = "AAU",
  /**
   * Clearance invoice information
   */
  ClearanceInvoiceInformation = "AAV",
  /**
   * Letter of credit information
   */
  LetterCreditInformation = "AAW",
  /**
   * License information
   */
  LicenseInformation = "AAX",
  /**
   * Certification statements
   */
  CertificationStatements = "AAY",
  /**
   * Additional export information
   */
  AdditionalExportInformation = "AAZ",
  /**
   * Tariff statements
   */
  TariffStatements = "ABA",
  /**
   * Medical history
   */
  MedicalHistory = "ABB",
  /**
   * Conditions of sale or purchase
   */
  ConditionsSaleOrPurchase = "ABC",
  /**
   * Contract document type
   */
  ContractDocumentType = "ABD",
  /**
   * Additional terms and/or conditions (documentary credit)
   */
  AdditionalTermsAndOrConditionsDocumentaryCredit = "ABE",
  /**
   * Instructions or information about standby documentary
   */
  InstructionsOrInformationAboutStandbyDocumentary = "ABF",
  /**
   * Instructions or information about partial shipment(s)
   */
  InstructionsOrInformationAboutPartialShipmentS = "ABG",
  /**
   * Instructions or information about transhipment(s)
   */
  InstructionsOrInformationAboutTranshipmentS = "ABH",
  /**
   * Additional handling instructions documentary credit
   */
  AdditionalHandlingInstructionsDocumentaryCredit = "ABI",
  /**
   * Domestic routing information
   */
  DomesticRoutingInformation = "ABJ",
  /**
   * Chargeable category of equipment
   */
  ChargeableCategoryEquipment = "ABK",
  /**
   * Government information
   */
  GovernmentInformation = "ABL",
  /**
   * Onward routing information
   */
  OnwardRoutingInformation = "ABM",
  /**
   * Accounting information
   */
  AccountingInformation = "ABN",
  /**
   * Discrepancy information
   */
  DiscrepancyInformation = "ABO",
  /**
   * Confirmation instructions
   */
  ConfirmationInstructions = "ABP",
  /**
   * Method of issuance
   */
  MethodIssuance = "ABQ",
  /**
   * Documents delivery instructions
   */
  DocumentsDeliveryInstructions = "ABR",
  /**
   * Additional conditions
   */
  AdditionalConditions = "ABS",
  /**
   * Information/instructions about additional amounts covered
   */
  InformationInstructionsAboutAdditionalAmountsCovered = "ABT",
  /**
   * Deferred payment termed additional
   */
  DeferredPaymentTermedAdditional = "ABU",
  /**
   * Acceptance terms additional
   */
  AcceptanceTermsAdditional = "ABV",
  /**
   * Negotiation terms additional
   */
  NegotiationTermsAdditional = "ABW",
  /**
   * Document name and documentary requirements
   */
  DocumentNameAndDocumentaryRequirements = "ABX",
  /**
   * Instructions/information about revolving documentary credit
   */
  InstructionsInformationAboutRevolvingDocumentaryCredit = "ABZ",
  /**
   * Documentary requirements
   */
  DocumentaryRequirements = "ACA",
  /**
   * Additional information
   */
  AdditionalInformation = "ACB",
  /**
   * Factor assignment clause
   */
  FactorAssignmentClause = "ACC",
  /**
   * Reason
   */
  Reason = "ACD",
  /**
   * Dispute
   */
  Dispute = "ACE",
  /**
   * Additional attribute information
   */
  AdditionalAttributeInformation = "ACF",
  /**
   * Absence declaration
   */
  AbsenceDeclaration = "ACG",
  /**
   * Aggregation statement
   */
  AggregationStatement = "ACH",
  /**
   * Compilation statement
   */
  CompilationStatement = "ACI",
  /**
   * Definitional exception
   */
  DefinitionalException = "ACJ",
  /**
   * Privacy statement
   */
  PrivacyStatement = "ACK",
  /**
   * Quality statement
   */
  QualityStatement = "ACL",
  /**
   * Statistical description
   */
  StatisticalDescription = "ACM",
  /**
   * Statistical definition
   */
  StatisticalDefinition = "ACN",
  /**
   * Statistical name
   */
  StatisticalName = "ACO",
  /**
   * Statistical title
   */
  StatisticalTitle = "ACP",
  /**
   * Off-dimension information
   */
  OffDimensionInformation = "ACQ",
  /**
   * Unexpected stops information
   */
  UnexpectedStopsInformation = "ACR",
  /**
   * Principles
   */
  Principles = "ACS",
  /**
   * Terms and definition
   */
  TermsAndDefinition = "ACT",
  /**
   * Segment name
   */
  SegmentName = "ACU",
  /**
   * Simple data element name
   */
  SimpleDataElementName = "ACV",
  /**
   * Scope
   */
  Scope = "ACW",
  /**
   * Message type name
   */
  MessageTypeName = "ACX",
  /**
   * Introduction
   */
  Introduction = "ACY",
  /**
   * Glossary
   */
  Glossary = "ACZ",
  /**
   * Functional definition
   */
  FunctionalDefinition = "ADA",
  /**
   * Examples
   */
  Examples = "ADB",
  /**
   * Cover page
   */
  CoverPage = "ADC",
  /**
   * Dependency (syntax) notes
   */
  DependencySyntaxNotes = "ADD",
  /**
   * Code value name
   */
  CodeValueName = "ADE",
  /**
   * Code list name
   */
  CodeListName = "ADF",
  /**
   * Clarification of usage
   */
  ClarificationUsage = "ADG",
  /**
   * Composite data element name
   */
  CompositeDataElementName = "ADH",
  /**
   * Field of application
   */
  FieldApplication = "ADI",
  /**
   * Type of assets and liabilities
   */
  TypeAssetsAndLiabilities = "ADJ",
  /**
   * Promotion information
   */
  PromotionInformation = "ADK",
  /**
   * Meter condition
   */
  MeterCondition = "ADL",
  /**
   * Meter reading information
   */
  MeterReadingInformation = "ADM",
  /**
   * Type of transaction reason
   */
  TypeTransactionReason = "ADN",
  /**
   * Type of survey question
   */
  TypeSurveyQuestion = "ADO",
  /**
   * Carrier's agent counter information
   */
  CarriersAgentCounterInformation = "ADP",
  /**
   * Description of work item on equipment
   */
  DescriptionWorkItemOnEquipment = "ADQ",
  /**
   * Message definition
   */
  MessageDefinition = "ADR",
  /**
   * Booked item information
   */
  BookedItemInformation = "ADS",
  /**
   * Source of document
   */
  SourceDocument = "ADT",
  /**
   * Note
   */
  Note = "ADU",
  /**
   * Fixed part of segment clarification text
   */
  FixedPartSegmentClarificationText = "ADV",
  /**
   * Characteristics of goods
   */
  CharacteristicsGoods = "ADW",
  /**
   * Additional discharge instructions
   */
  AdditionalDischargeInstructions = "ADX",
  /**
   * Container stripping instructions
   */
  ContainerStrippingInstructions = "ADY",
  /**
   * CSC (Container Safety Convention) plate information
   */
  CscContainerSafetyConventionPlateInformation = "ADZ",
  /**
   * Cargo remarks
   */
  CargoRemarks = "AEA",
  /**
   * Temperature control instructions
   */
  TemperatureControlInstructions = "AEB",
  /**
   * Text refers to expected data
   */
  TextRefersToExpectedData = "AEC",
  /**
   * Text refers to received data
   */
  TextRefersToReceivedData = "AED",
  /**
   * Section clarification text
   */
  SectionClarificationText = "AEE",
  /**
   * Information to the beneficiary
   */
  InformationToBeneficiary = "AEF",
  /**
   * Information to the applicant
   */
  InformationToApplicant = "AEG",
  /**
   * Instructions to the beneficiary
   */
  InstructionsToBeneficiary = "AEH",
  /**
   * Instructions to the applicant
   */
  InstructionsToApplicant = "AEI",
  /**
   * Controlled atmosphere
   */
  ControlledAtmosphere = "AEJ",
  /**
   * Take off annotation
   */
  TakeOffAnnotation = "AEK",
  /**
   * Price variation narrative
   */
  PriceVariationNarrative = "AEL",
  /**
   * Documentary credit amendment instructions
   */
  DocumentaryCreditAmendmentInstructions = "AEM",
  /**
   * Standard method narrative
   */
  StandardMethodNarrative = "AEN",
  /**
   * Project narrative
   */
  ProjectNarrative = "AEO",
  /**
   * Radioactive goods, additional information
   */
  RadioactiveGoodsAdditionalInformation = "AEP",
  /**
   * Bank-to-bank information
   */
  BankToBankInformation = "AEQ",
  /**
   * Reimbursement instructions
   */
  ReimbursementInstructions = "AER",
  /**
   * Reason for amending a message
   */
  ReasonForAmendingAMessage = "AES",
  /**
   * Instructions to the paying and/or accepting and/or
   */
  InstructionsToPayingAndOrAcceptingAndOr = "AET",
  /**
   * Interest instructions
   */
  InterestInstructions = "AEU",
  /**
   * Agent commission
   */
  AgentCommission = "AEV",
  /**
   * Remitting bank instructions
   */
  RemittingBankInstructions = "AEW",
  /**
   * Instructions to the collecting bank
   */
  InstructionsToCollectingBank = "AEX",
  /**
   * Collection amount instructions
   */
  CollectionAmountInstructions = "AEY",
  /**
   * Internal auditing information
   */
  InternalAuditingInformation = "AEZ",
  /**
   * Constraint
   */
  Constraint = "AFA",
  /**
   * Comment
   */
  Comment = "AFB",
  /**
   * Semantic note
   */
  SemanticNote = "AFC",
  /**
   * Help text
   */
  HelpText = "AFD",
  /**
   * Legend
   */
  Legend = "AFE",
  /**
   * Batch code structure
   */
  BatchCodeStructure = "AFF",
  /**
   * Product application
   */
  ProductApplication = "AFG",
  /**
   * Customer complaint
   */
  CustomerComplaint = "AFH",
  /**
   * Probable cause of fault
   */
  ProbableCauseFault = "AFI",
  /**
   * Defect description
   */
  DefectDescription = "AFJ",
  /**
   * Repair description
   */
  RepairDescription = "AFK",
  /**
   * Review comments
   */
  ReviewComments = "AFL",
  /**
   * Title
   */
  Title = "AFM",
  /**
   * Description of amount
   */
  DescriptionAmount = "AFN",
  /**
   * Responsibilities
   */
  Responsibilities = "AFO",
  /**
   * Supplier
   */
  Supplier = "AFP",
  /**
   * Purchase region
   */
  PurchaseRegion = "AFQ",
  /**
   * Affiliation
   */
  Affiliation = "AFR",
  /**
   * Borrower
   */
  Borrower = "AFS",
  /**
   * Line of business
   */
  LineBusiness = "AFT",
  /**
   * Financial institution
   */
  FinancialInstitution = "AFU",
  /**
   * Business founder
   */
  BusinessFounder = "AFV",
  /**
   * Business history
   */
  BusinessHistory = "AFW",
  /**
   * Banking arrangements
   */
  BankingArrangements = "AFX",
  /**
   * Business origin
   */
  BusinessOrigin = "AFY",
  /**
   * Brand names' description
   */
  BrandNamesDescription = "AFZ",
  /**
   * Business financing details
   */
  BusinessFinancingDetails = "AGA",
  /**
   * Competition
   */
  Competition = "AGB",
  /**
   * Construction process details
   */
  ConstructionProcessDetails = "AGC",
  /**
   * Construction specialty
   */
  ConstructionSpecialty = "AGD",
  /**
   * Contract information
   */
  ContractInformation = "AGE",
  /**
   * Corporate filing
   */
  CorporateFiling = "AGF",
  /**
   * Customer information
   */
  CustomerInformation = "AGG",
  /**
   * Copyright notice
   */
  CopyrightNotice = "AGH",
  /**
   * Contingent debt
   */
  ContingentDebt = "AGI",
  /**
   * Conviction details
   */
  ConvictionDetails = "AGJ",
  /**
   * Equipment
   */
  Equipment = "AGK",
  /**
   * Workforce description
   */
  WorkforceDescription = "AGL",
  /**
   * Exemption
   */
  Exemption = "AGM",
  /**
   * Future plans
   */
  FuturePlans = "AGN",
  /**
   * Interviewee conversation information
   */
  IntervieweeConversationInformation = "AGO",
  /**
   * Intangible asset
   */
  IntangibleAsset = "AGP",
  /**
   * Inventory
   */
  Inventory = "AGQ",
  /**
   * Investment
   */
  Investment = "AGR",
  /**
   * Intercompany relations information
   */
  IntercompanyRelationsInformation = "AGS",
  /**
   * Joint venture
   */
  JointVenture = "AGT",
  /**
   * Loan
   */
  Loan = "AGU",
  /**
   * Long term debt
   */
  LongTermDebt = "AGV",
  /**
   * Location
   */
  Location = "AGW",
  /**
   * Current legal structure
   */
  CurrentLegalStructure = "AGX",
  /**
   * Marital contract
   */
  MaritalContract = "AGY",
  /**
   * Marketing activities
   */
  MarketingActivities = "AGZ",
  /**
   * Merger
   */
  Merger = "AHA",
  /**
   * Marketable securities
   */
  MarketableSecurities = "AHB",
  /**
   * Business debt
   */
  BusinessDebt = "AHC",
  /**
   * Original legal structure
   */
  OriginalLegalStructure = "AHD",
  /**
   * Employee sharing arrangements
   */
  EmployeeSharingArrangements = "AHE",
  /**
   * Organization details
   */
  OrganizationDetails = "AHF",
  /**
   * Public record details
   */
  PublicRecordDetails = "AHG",
  /**
   * Price range
   */
  PriceRange = "AHH",
  /**
   * Qualifications
   */
  Qualifications = "AHI",
  /**
   * Registered activity
   */
  RegisteredActivity = "AHJ",
  /**
   * Criminal sentence
   */
  CriminalSentence = "AHK",
  /**
   * Sales method
   */
  SalesMethod = "AHL",
  /**
   * Educational institution information
   */
  EducationalInstitutionInformation = "AHM",
  /**
   * Status details
   */
  StatusDetails = "AHN",
  /**
   * Sales
   */
  Sales = "AHO",
  /**
   * Spouse information
   */
  SpouseInformation = "AHP",
  /**
   * Educational degree information
   */
  EducationalDegreeInformation = "AHQ",
  /**
   * Shareholding information
   */
  ShareholdingInformation = "AHR",
  /**
   * Sales territory
   */
  SalesTerritory = "AHS",
  /**
   * Accountant's comments
   */
  AccountantsComments = "AHT",
  /**
   * Exemption law location
   */
  ExemptionLawLocation = "AHU",
  /**
   * Share classifications
   */
  ShareClassifications = "AHV",
  /**
   * Forecast
   */
  Forecast = "AHW",
  /**
   * Event location
   */
  EventLocation = "AHX",
  /**
   * Facility occupancy
   */
  FacilityOccupancy = "AHY",
  /**
   * Import and export details
   */
  ImportAndExportDetails = "AHZ",
  /**
   * Additional facility information
   */
  AdditionalFacilityInformation = "AIA",
  /**
   * Inventory value
   */
  InventoryValue = "AIB",
  /**
   * Education
   */
  Education = "AIC",
  /**
   * Event
   */
  Event = "AID",
  /**
   * Agent
   */
  Agent = "AIE",
  /**
   * Domestically agreed financial statement details
   */
  DomesticallyAgreedFinancialStatementDetails = "AIF",
  /**
   * Other current asset description
   */
  OtherCurrentAssetDescription = "AIG",
  /**
   * Other current liability description
   */
  OtherCurrentLiabilityDescription = "AIH",
  /**
   * Former business activity
   */
  FormerBusinessActivity = "AII",
  /**
   * Trade name use
   */
  TradeNameUse = "AIJ",
  /**
   * Signing authority
   */
  SigningAuthority = "AIK",
  /**
   * Guarantee
   */
  Guarantee = "AIL",
  /**
   * Holding company operation
   */
  HoldingCompanyOperation = "AIM",
  /**
   * Consignment routing
   */
  ConsignmentRouting = "AIN",
  /**
   * Letter of protest
   */
  LetterProtest = "AIO",
  /**
   * Question
   */
  Question = "AIP",
  /**
   * Party information
   */
  PartyInformation = "AIQ",
  /**
   * Area boundaries description
   */
  AreaBoundariesDescription = "AIR",
  /**
   * Advertisement information
   */
  AdvertisementInformation = "AIS",
  /**
   * Financial statement details
   */
  FinancialStatementDetails = "AIT",
  /**
   * Access instructions
   */
  AccessInstructions = "AIU",
  /**
   * Liquidity
   */
  Liquidity = "AIV",
  /**
   * Credit line
   */
  CreditLine = "AIW",
  /**
   * Warranty terms
   */
  WarrantyTerms = "AIX",
  /**
   * Division description
   */
  DivisionDescription = "AIY",
  /**
   * Reporting instruction
   */
  ReportingInstruction = "AIZ",
  /**
   * Examination result
   */
  ExaminationResult = "AJA",
  /**
   * Laboratory result
   */
  LaboratoryResult = "AJB",
  /**
   * Allowance/charge information
   */
  AllowanceChargeInformation = "ALC",
  /**
   * X-ray result
   */
  XRayResult = "ALD",
  /**
   * Pathology result
   */
  PathologyResult = "ALE",
  /**
   * Intervention description
   */
  InterventionDescription = "ALF",
  /**
   * Summary of admittance
   */
  SummaryAdmittance = "ALG",
  /**
   * Medical treatment course detail
   */
  MedicalTreatmentCourseDetail = "ALH",
  /**
   * Prognosis
   */
  Prognosis = "ALI",
  /**
   * Instruction to patient
   */
  InstructionToPatient = "ALJ",
  /**
   * Instruction to physician
   */
  InstructionToPhysician = "ALK",
  /**
   * All documents
   */
  AllDocuments = "ALL",
  /**
   * Medicine treatment
   */
  MedicineTreatment = "ALM",
  /**
   * Medicine dosage and administration
   */
  MedicineDosageAndAdministration = "ALN",
  /**
   * Availability of patient
   */
  AvailabilityPatient = "ALO",
  /**
   * Reason for service request
   */
  ReasonForServiceRequest = "ALP",
  /**
   * Purpose of service
   */
  PurposeService = "ALQ",
  /**
   * Arrival conditions
   */
  ArrivalConditions = "ARR",
  /**
   * Service requester's comment
   */
  ServiceRequestersComment = "ARS",
  /**
   * Authentication
   */
  Authentication = "AUT",
  /**
   * Requested location description
   */
  RequestedLocationDescription = "AUU",
  /**
   * Medicine administration condition
   */
  MedicineAdministrationCondition = "AUV",
  /**
   * Patient information
   */
  PatientInformation = "AUW",
  /**
   * Precautionary measure
   */
  PrecautionaryMeasure = "AUX",
  /**
   * Service characteristic
   */
  ServiceCharacteristic = "AUY",
  /**
   * Planned event comment
   */
  PlannedEventComment = "AUZ",
  /**
   * Expected delay comment
   */
  ExpectedDelayComment = "AVA",
  /**
   * Transport requirements comment
   */
  TransportRequirementsComment = "AVB",
  /**
   * Temporary approval condition
   */
  TemporaryApprovalCondition = "AVC",
  /**
   * Customs Valuation Information
   */
  CustomsValuationInformation = "AVD",
  /**
   * Value Added Tax (VAT) margin scheme
   */
  ValueAddedTaxVatMarginScheme = "AVE",
  /**
   * Maritime Declaration of Health
   */
  MaritimeDeclarationHealth = "AVF",
  /**
   * Passenger baggage information
   */
  PassengerBaggageInformation = "BAG",
  /**
   * Maritime Declaration of Health
   */
  MaritimeDeclarationHealth_Dup = "BAH",
  /**
   * Additional product information address
   */
  AdditionalProductInformationAddress = "BAI",
  /**
   * Information to be printed on despatch advice
   */
  InformationToBePrintedOnDespatchAdvice = "BAJ",
  /**
   * Missing goods remarks
   */
  MissingGoodsRemarks = "BAK",
  /**
   * Non-acceptance information
   */
  NonAcceptanceInformation = "BAL",
  /**
   * Returns information
   */
  ReturnsInformation = "BAM",
  /**
   * Sub-line item information
   */
  SubLineItemInformation = "BAN",
  /**
   * Test information
   */
  TestInformation = "BAO",
  /**
   * External link
   */
  ExternalLink = "BAP",
  /**
   * VAT exemption reason
   */
  VatExemptionReason = "BAQ",
  /**
   * Processing Instructions
   */
  ProcessingInstructions = "BAR",
  /**
   * Relay Instructions
   */
  RelayInstructions = "BAS",
  /**
   * SIMA applicable
   */
  SimaApplicable = "BAT",
  /**
   * Appeals program code
   */
  AppealsProgramCode = "BAU",
  /**
   * SIMA subject
   */
  SimaSubject = "BAV",
  /**
   * Surtax applicable
   */
  SurtaxApplicable = "BAW",
  /**
   * SIMA security bond
   */
  SimaSecurityBond = "BAX",
  /**
   * Surtax subject
   */
  SurtaxSubject = "BAY",
  /**
   * Safeguard applicable
   */
  SafeguardApplicable = "BAZ",
  /**
   * Safeguard applicable
   */
  SafeguardApplicable_Dup = "BBA",
  /**
   * Safeguard subject
   */
  SafeguardSubject = "BBB",
  /**
   * Transport contract document clause
   */
  TransportContractDocumentClause = "BLC",
  /**
   * Instruction to prepare the patient
   */
  InstructionToPreparePatient = "BLD",
  /**
   * Medicine treatment comment
   */
  MedicineTreatmentComment = "BLE",
  /**
   * Examination result comment
   */
  ExaminationResultComment = "BLF",
  /**
   * Service request comment
   */
  ServiceRequestComment = "BLG",
  /**
   * Prescription reason
   */
  PrescriptionReason = "BLH",
  /**
   * Prescription comment
   */
  PrescriptionComment = "BLI",
  /**
   * Clinical investigation comment
   */
  ClinicalInvestigationComment = "BLJ",
  /**
   * Medicinal specification comment
   */
  MedicinalSpecificationComment = "BLK",
  /**
   * Economic contribution comment
   */
  EconomicContributionComment = "BLL",
  /**
   * Status of a plan
   */
  StatusAPlan = "BLM",
  /**
   * Random sample test information
   */
  RandomSampleTestInformation = "BLN",
  /**
   * Period of time
   */
  PeriodTime = "BLO",
  /**
   * Legislation
   */
  Legislation = "BLP",
  /**
   * Security measures requested
   */
  SecurityMeasuresRequested = "BLQ",
  /**
   * Transport contract document remark
   */
  TransportContractDocumentRemark = "BLR",
  /**
   * Previous port of call security information
   */
  PreviousPortCallSecurityInformation = "BLS",
  /**
   * Security information
   */
  SecurityInformation = "BLT",
  /**
   * Waste information
   */
  WasteInformation = "BLU",
  /**
   * B2C marketing information, short description
   */
  B2cMarketingInformationShortDescription = "BLV",
  /**
   * B2B marketing information, long description
   */
  B2bMarketingInformationLongDescription = "BLW",
  /**
   * B2C marketing information, long description
   */
  B2cMarketingInformationLongDescription = "BLX",
  /**
   * Product ingredients
   */
  ProductIngredients = "BLY",
  /**
   * Location short name
   */
  LocationShortName = "BLZ",
  /**
   * Packaging material information
   */
  PackagingMaterialInformation = "BMA",
  /**
   * Filler material information
   */
  FillerMaterialInformation = "BMB",
  /**
   * Ship-to-ship activity information
   */
  ShipToShipActivityInformation = "BMC",
  /**
   * Package material description
   */
  PackageMaterialDescription = "BMD",
  /**
   * Consumer level package marking
   */
  ConsumerLevelPackageMarking = "BME",
  /**
   * SIMA measure in force
   */
  SimaMeasureInForce = "BMF",
  /**
   * Pre-CARM
   */
  PreCarm = "BMG",
  /**
   * SIMA measure type
   */
  SimaMeasureType = "BMH",
  /**
   * Customs clearance instructions
   */
  CustomsClearanceInstructions = "CCI",
  /**
   * Sub Type Code
   */
  SubTypeCode = "CCJ",
  /**
   * SIMA information
   */
  SimaInformation = "CCK",
  /**
   * Time limit end
   */
  TimeLimitEnd = "CCL",
  /**
   * Time limit start
   */
  TimeLimitStart = "CCM",
  /**
   * Warehouse time limit
   */
  WarehouseTimeLimit = "CCN",
  /**
   * Value for duty information
   */
  ValueForDutyInformation = "CCO",
  /**
   * Customs clearance instructions export
   */
  CustomsClearanceInstructionsExport = "CEX",
  /**
   * Change information
   */
  ChangeInformation = "CHG",
  /**
   * Customs clearance instruction import
   */
  CustomsClearanceInstructionImport = "CIP",
  /**
   * Clearance place requested
   */
  ClearancePlaceRequested = "CLP",
  /**
   * Loading remarks
   */
  LoadingRemarks = "CLR",
  /**
   * Order information
   */
  OrderInformation = "COI",
  /**
   * Customer remarks
   */
  CustomerRemarks = "CUR",
  /**
   * Customs declaration information
   */
  CustomsDeclarationInformation = "CUS",
  /**
   * Damage remarks
   */
  DamageRemarks = "DAR",
  /**
   * Document issuer declaration
   */
  DocumentIssuerDeclaration = "DCL",
  /**
   * Delivery information
   */
  DeliveryInformation = "DEL",
  /**
   * Delivery instructions
   */
  DeliveryInstructions = "DIN",
  /**
   * Documentation instructions
   */
  DocumentationInstructions = "DOC",
  /**
   * Duty declaration
   */
  DutyDeclaration = "DUT",
  /**
   * Effective used routing
   */
  EffectiveUsedRouting = "EUR",
  /**
   * First block to be printed on the transport contract
   */
  FirstBlockToBePrintedOnTransportContract = "FBC",
  /**
   * Government bill of lading information
   */
  GovernmentBillLadingInformation = "GBL",
  /**
   * Entire transaction set
   */
  EntireTransactionSet = "GEN",
  /**
   * Further information concerning GGVS par. 7
   */
  FurtherInformationConcerningGgvsPar7 = "GS7",
  /**
   * Consignment handling instruction
   */
  ConsignmentHandlingInstruction = "HAN",
  /**
   * Hazard information
   */
  HazardInformation = "HAZ",
  /**
   * Consignment information for consignee
   */
  ConsignmentInformationForConsignee = "ICN",
  /**
   * Insurance instructions
   */
  InsuranceInstructions = "IIN",
  /**
   * Invoice mailing instructions
   */
  InvoiceMailingInstructions = "IMI",
  /**
   * Commercial invoice item description
   */
  CommercialInvoiceItemDescription = "IND",
  /**
   * Insurance information
   */
  InsuranceInformation = "INS",
  /**
   * Invoice instruction
   */
  InvoiceInstruction = "INV",
  /**
   * Information for railway purpose
   */
  InformationForRailwayPurpose = "IRP",
  /**
   * Inland transport details
   */
  InlandTransportDetails = "ITR",
  /**
   * Testing instructions
   */
  TestingInstructions = "ITS",
  /**
   * Location Alias
   */
  LocationAlias = "LAN",
  /**
   * Line item
   */
  LineItem = "LIN",
  /**
   * Loading instruction
   */
  LoadingInstruction = "LOI",
  /**
   * Miscellaneous charge order
   */
  MiscellaneousChargeOrder = "MCO",
  /**
   * Maritime Declaration of Health
   */
  MaritimeDeclarationHealth_Dup_Dup = "MDH",
  /**
   * Additional marks/numbers information
   */
  AdditionalMarksNumbersInformation = "MKS",
  /**
   * Order instruction
   */
  OrderInstruction = "ORI",
  /**
   * Other service information
   */
  OtherServiceInformation = "OSI",
  /**
   * Packing/marking information
   */
  PackingMarkingInformation = "PAC",
  /**
   * Payment instructions information
   */
  PaymentInstructionsInformation = "PAI",
  /**
   * Payables information
   */
  PayablesInformation = "PAY",
  /**
   * Packaging information
   */
  PackagingInformation = "PKG",
  /**
   * Packaging terms information
   */
  PackagingTermsInformation = "PKT",
  /**
   * Payment detail/remittance information
   */
  PaymentDetailRemittanceInformation = "PMD",
  /**
   * Payment information
   */
  PaymentInformation = "PMT",
  /**
   * Product information
   */
  ProductInformation = "PRD",
  /**
   * Price calculation formula
   */
  PriceCalculationFormula = "PRF",
  /**
   * Priority information
   */
  PriorityInformation = "PRI",
  /**
   * Purchasing information
   */
  PurchasingInformation = "PUR",
  /**
   * Quarantine instructions
   */
  QuarantineInstructions = "QIN",
  /**
   * Quality demands/requirements
   */
  QualityDemandsRequirements = "QQD",
  /**
   * Quotation instruction/information
   */
  QuotationInstructionInformation = "QUT",
  /**
   * Risk and handling information
   */
  RiskAndHandlingInformation = "RAH",
  /**
   * Regulatory information
   */
  RegulatoryInformation = "REG",
  /**
   * Return to origin information
   */
  ReturnToOriginInformation = "RET",
  /**
   * Receivables
   */
  Receivables = "REV",
  /**
   * Consignment route
   */
  ConsignmentRoute = "RQR",
  /**
   * Safety information
   */
  SafetyInformation = "SAF",
  /**
   * Consignment documentary instruction
   */
  ConsignmentDocumentaryInstruction = "SIC",
  /**
   * Special instructions
   */
  SpecialInstructions = "SIN",
  /**
   * Ship line requested
   */
  ShipLineRequested = "SLR",
  /**
   * Special permission for transport, generally
   */
  SpecialPermissionForTransportGenerally = "SPA",
  /**
   * Special permission concerning the goods to be transported
   */
  SpecialPermissionConcerningGoodsToBeTransported = "SPG",
  /**
   * Special handling
   */
  SpecialHandling = "SPH",
  /**
   * Special permission concerning package
   */
  SpecialPermissionConcerningPackage = "SPP",
  /**
   * Special permission concerning transport means
   */
  SpecialPermissionConcerningTransportMeans = "SPT",
  /**
   * Subsidiary risk number (IATA/DGR)
   */
  SubsidiaryRiskNumberIataDgr = "SRN",
  /**
   * Special service request
   */
  SpecialServiceRequest = "SSR",
  /**
   * Supplier remarks
   */
  SupplierRemarks = "SUR",
  /**
   * Consignment tariff
   */
  ConsignmentTariff = "TCA",
  /**
   * Consignment transport
   */
  ConsignmentTransport = "TDT",
  /**
   * Transportation information
   */
  TransportationInformation = "TRA",
  /**
   * Requested tariff
   */
  RequestedTariff = "TRR",
  /**
   * Tax declaration
   */
  TaxDeclaration = "TXD",
  /**
   * Warehouse instruction/information
   */
  WarehouseInstructionInformation = "WHI",
  /**
   * Mutually defined
   */
  MutuallyDefined = "ZZZ",
}

export function description(value: Text): string {
  switch (value) {
    case Text.GoodsItemDescription:
      return "Goods item description";
    case Text.PaymentTerm:
      return "Payment term";
    case Text.DangerousGoodsAdditionalInformation:
      return "Dangerous goods additional information";
    case Text.DangerousGoodsTechnicalName:
      return "Dangerous goods technical name";
    case Text.AcknowledgementDescription:
      return "Acknowledgement description";
    case Text.RateAdditionalInformation:
      return "Rate additional information";
    case Text.PartyInstructions:
      return "Party instructions";
    case Text.GeneralInformation:
      return "General information";
    case Text.AdditionalConditionsSalePurchase:
      return "Additional conditions of sale/purchase";
    case Text.PriceConditions:
      return "Price conditions";
    case Text.GoodsDimensionsInCharacters:
      return "Goods dimensions in characters";
    case Text.EquipmentReUsageRestrictions:
      return "Equipment re-usage restrictions";
    case Text.HandlingRestriction:
      return "Handling restriction";
    case Text.ErrorDescriptionFreeText:
      return "Error description (free text)";
    case Text.ResponseFreeText:
      return "Response (free text)";
    case Text.PackageContentsDescription:
      return "Package content's description";
    case Text.TermsDelivery:
      return "Terms of delivery";
    case Text.BillLadingRemarks:
      return "Bill of lading remarks";
    case Text.ModeSettlementInformation:
      return "Mode of settlement information";
    case Text.ConsignmentInvoiceInformation:
      return "Consignment invoice information";
    case Text.ClearanceInvoiceInformation:
      return "Clearance invoice information";
    case Text.LetterCreditInformation:
      return "Letter of credit information";
    case Text.LicenseInformation:
      return "License information";
    case Text.CertificationStatements:
      return "Certification statements";
    case Text.AdditionalExportInformation:
      return "Additional export information";
    case Text.TariffStatements:
      return "Tariff statements";
    case Text.MedicalHistory:
      return "Medical history";
    case Text.ConditionsSaleOrPurchase:
      return "Conditions of sale or purchase";
    case Text.ContractDocumentType:
      return "Contract document type";
    case Text.AdditionalTermsAndOrConditionsDocumentaryCredit:
      return "Additional terms and/or conditions (documentary credit)";
    case Text.InstructionsOrInformationAboutStandbyDocumentary:
      return "Instructions or information about standby documentary";
    case Text.InstructionsOrInformationAboutPartialShipmentS:
      return "Instructions or information about partial shipment(s)";
    case Text.InstructionsOrInformationAboutTranshipmentS:
      return "Instructions or information about transhipment(s)";
    case Text.AdditionalHandlingInstructionsDocumentaryCredit:
      return "Additional handling instructions documentary credit";
    case Text.DomesticRoutingInformation:
      return "Domestic routing information";
    case Text.ChargeableCategoryEquipment:
      return "Chargeable category of equipment";
    case Text.GovernmentInformation:
      return "Government information";
    case Text.OnwardRoutingInformation:
      return "Onward routing information";
    case Text.AccountingInformation:
      return "Accounting information";
    case Text.DiscrepancyInformation:
      return "Discrepancy information";
    case Text.ConfirmationInstructions:
      return "Confirmation instructions";
    case Text.MethodIssuance:
      return "Method of issuance";
    case Text.DocumentsDeliveryInstructions:
      return "Documents delivery instructions";
    case Text.AdditionalConditions:
      return "Additional conditions";
    case Text.InformationInstructionsAboutAdditionalAmountsCovered:
      return "Information/instructions about additional amounts covered";
    case Text.DeferredPaymentTermedAdditional:
      return "Deferred payment termed additional";
    case Text.AcceptanceTermsAdditional:
      return "Acceptance terms additional";
    case Text.NegotiationTermsAdditional:
      return "Negotiation terms additional";
    case Text.DocumentNameAndDocumentaryRequirements:
      return "Document name and documentary requirements";
    case Text.InstructionsInformationAboutRevolvingDocumentaryCredit:
      return "Instructions/information about revolving documentary credit";
    case Text.DocumentaryRequirements:
      return "Documentary requirements";
    case Text.AdditionalInformation:
      return "Additional information";
    case Text.FactorAssignmentClause:
      return "Factor assignment clause";
    case Text.Reason:
      return "Reason";
    case Text.Dispute:
      return "Dispute";
    case Text.AdditionalAttributeInformation:
      return "Additional attribute information";
    case Text.AbsenceDeclaration:
      return "Absence declaration";
    case Text.AggregationStatement:
      return "Aggregation statement";
    case Text.CompilationStatement:
      return "Compilation statement";
    case Text.DefinitionalException:
      return "Definitional exception";
    case Text.PrivacyStatement:
      return "Privacy statement";
    case Text.QualityStatement:
      return "Quality statement";
    case Text.StatisticalDescription:
      return "Statistical description";
    case Text.StatisticalDefinition:
      return "Statistical definition";
    case Text.StatisticalName:
      return "Statistical name";
    case Text.StatisticalTitle:
      return "Statistical title";
    case Text.OffDimensionInformation:
      return "Off-dimension information";
    case Text.UnexpectedStopsInformation:
      return "Unexpected stops information";
    case Text.Principles:
      return "Principles";
    case Text.TermsAndDefinition:
      return "Terms and definition";
    case Text.SegmentName:
      return "Segment name";
    case Text.SimpleDataElementName:
      return "Simple data element name";
    case Text.Scope:
      return "Scope";
    case Text.MessageTypeName:
      return "Message type name";
    case Text.Introduction:
      return "Introduction";
    case Text.Glossary:
      return "Glossary";
    case Text.FunctionalDefinition:
      return "Functional definition";
    case Text.Examples:
      return "Examples";
    case Text.CoverPage:
      return "Cover page";
    case Text.DependencySyntaxNotes:
      return "Dependency (syntax) notes";
    case Text.CodeValueName:
      return "Code value name";
    case Text.CodeListName:
      return "Code list name";
    case Text.ClarificationUsage:
      return "Clarification of usage";
    case Text.CompositeDataElementName:
      return "Composite data element name";
    case Text.FieldApplication:
      return "Field of application";
    case Text.TypeAssetsAndLiabilities:
      return "Type of assets and liabilities";
    case Text.PromotionInformation:
      return "Promotion information";
    case Text.MeterCondition:
      return "Meter condition";
    case Text.MeterReadingInformation:
      return "Meter reading information";
    case Text.TypeTransactionReason:
      return "Type of transaction reason";
    case Text.TypeSurveyQuestion:
      return "Type of survey question";
    case Text.CarriersAgentCounterInformation:
      return "Carrier's agent counter information";
    case Text.DescriptionWorkItemOnEquipment:
      return "Description of work item on equipment";
    case Text.MessageDefinition:
      return "Message definition";
    case Text.BookedItemInformation:
      return "Booked item information";
    case Text.SourceDocument:
      return "Source of document";
    case Text.Note:
      return "Note";
    case Text.FixedPartSegmentClarificationText:
      return "Fixed part of segment clarification text";
    case Text.CharacteristicsGoods:
      return "Characteristics of goods";
    case Text.AdditionalDischargeInstructions:
      return "Additional discharge instructions";
    case Text.ContainerStrippingInstructions:
      return "Container stripping instructions";
    case Text.CscContainerSafetyConventionPlateInformation:
      return "CSC (Container Safety Convention) plate information";
    case Text.CargoRemarks:
      return "Cargo remarks";
    case Text.TemperatureControlInstructions:
      return "Temperature control instructions";
    case Text.TextRefersToExpectedData:
      return "Text refers to expected data";
    case Text.TextRefersToReceivedData:
      return "Text refers to received data";
    case Text.SectionClarificationText:
      return "Section clarification text";
    case Text.InformationToBeneficiary:
      return "Information to the beneficiary";
    case Text.InformationToApplicant:
      return "Information to the applicant";
    case Text.InstructionsToBeneficiary:
      return "Instructions to the beneficiary";
    case Text.InstructionsToApplicant:
      return "Instructions to the applicant";
    case Text.ControlledAtmosphere:
      return "Controlled atmosphere";
    case Text.TakeOffAnnotation:
      return "Take off annotation";
    case Text.PriceVariationNarrative:
      return "Price variation narrative";
    case Text.DocumentaryCreditAmendmentInstructions:
      return "Documentary credit amendment instructions";
    case Text.StandardMethodNarrative:
      return "Standard method narrative";
    case Text.ProjectNarrative:
      return "Project narrative";
    case Text.RadioactiveGoodsAdditionalInformation:
      return "Radioactive goods, additional information";
    case Text.BankToBankInformation:
      return "Bank-to-bank information";
    case Text.ReimbursementInstructions:
      return "Reimbursement instructions";
    case Text.ReasonForAmendingAMessage:
      return "Reason for amending a message";
    case Text.InstructionsToPayingAndOrAcceptingAndOr:
      return "Instructions to the paying and/or accepting and/or";
    case Text.InterestInstructions:
      return "Interest instructions";
    case Text.AgentCommission:
      return "Agent commission";
    case Text.RemittingBankInstructions:
      return "Remitting bank instructions";
    case Text.InstructionsToCollectingBank:
      return "Instructions to the collecting bank";
    case Text.CollectionAmountInstructions:
      return "Collection amount instructions";
    case Text.InternalAuditingInformation:
      return "Internal auditing information";
    case Text.Constraint:
      return "Constraint";
    case Text.Comment:
      return "Comment";
    case Text.SemanticNote:
      return "Semantic note";
    case Text.HelpText:
      return "Help text";
    case Text.Legend:
      return "Legend";
    case Text.BatchCodeStructure:
      return "Batch code structure";
    case Text.ProductApplication:
      return "Product application";
    case Text.CustomerComplaint:
      return "Customer complaint";
    case Text.ProbableCauseFault:
      return "Probable cause of fault";
    case Text.DefectDescription:
      return "Defect description";
    case Text.RepairDescription:
      return "Repair description";
    case Text.ReviewComments:
      return "Review comments";
    case Text.Title:
      return "Title";
    case Text.DescriptionAmount:
      return "Description of amount";
    case Text.Responsibilities:
      return "Responsibilities";
    case Text.Supplier:
      return "Supplier";
    case Text.PurchaseRegion:
      return "Purchase region";
    case Text.Affiliation:
      return "Affiliation";
    case Text.Borrower:
      return "Borrower";
    case Text.LineBusiness:
      return "Line of business";
    case Text.FinancialInstitution:
      return "Financial institution";
    case Text.BusinessFounder:
      return "Business founder";
    case Text.BusinessHistory:
      return "Business history";
    case Text.BankingArrangements:
      return "Banking arrangements";
    case Text.BusinessOrigin:
      return "Business origin";
    case Text.BrandNamesDescription:
      return "Brand names' description";
    case Text.BusinessFinancingDetails:
      return "Business financing details";
    case Text.Competition:
      return "Competition";
    case Text.ConstructionProcessDetails:
      return "Construction process details";
    case Text.ConstructionSpecialty:
      return "Construction specialty";
    case Text.ContractInformation:
      return "Contract information";
    case Text.CorporateFiling:
      return "Corporate filing";
    case Text.CustomerInformation:
      return "Customer information";
    case Text.CopyrightNotice:
      return "Copyright notice";
    case Text.ContingentDebt:
      return "Contingent debt";
    case Text.ConvictionDetails:
      return "Conviction details";
    case Text.Equipment:
      return "Equipment";
    case Text.WorkforceDescription:
      return "Workforce description";
    case Text.Exemption:
      return "Exemption";
    case Text.FuturePlans:
      return "Future plans";
    case Text.IntervieweeConversationInformation:
      return "Interviewee conversation information";
    case Text.IntangibleAsset:
      return "Intangible asset";
    case Text.Inventory:
      return "Inventory";
    case Text.Investment:
      return "Investment";
    case Text.IntercompanyRelationsInformation:
      return "Intercompany relations information";
    case Text.JointVenture:
      return "Joint venture";
    case Text.Loan:
      return "Loan";
    case Text.LongTermDebt:
      return "Long term debt";
    case Text.Location:
      return "Location";
    case Text.CurrentLegalStructure:
      return "Current legal structure";
    case Text.MaritalContract:
      return "Marital contract";
    case Text.MarketingActivities:
      return "Marketing activities";
    case Text.Merger:
      return "Merger";
    case Text.MarketableSecurities:
      return "Marketable securities";
    case Text.BusinessDebt:
      return "Business debt";
    case Text.OriginalLegalStructure:
      return "Original legal structure";
    case Text.EmployeeSharingArrangements:
      return "Employee sharing arrangements";
    case Text.OrganizationDetails:
      return "Organization details";
    case Text.PublicRecordDetails:
      return "Public record details";
    case Text.PriceRange:
      return "Price range";
    case Text.Qualifications:
      return "Qualifications";
    case Text.RegisteredActivity:
      return "Registered activity";
    case Text.CriminalSentence:
      return "Criminal sentence";
    case Text.SalesMethod:
      return "Sales method";
    case Text.EducationalInstitutionInformation:
      return "Educational institution information";
    case Text.StatusDetails:
      return "Status details";
    case Text.Sales:
      return "Sales";
    case Text.SpouseInformation:
      return "Spouse information";
    case Text.EducationalDegreeInformation:
      return "Educational degree information";
    case Text.ShareholdingInformation:
      return "Shareholding information";
    case Text.SalesTerritory:
      return "Sales territory";
    case Text.AccountantsComments:
      return "Accountant's comments";
    case Text.ExemptionLawLocation:
      return "Exemption law location";
    case Text.ShareClassifications:
      return "Share classifications";
    case Text.Forecast:
      return "Forecast";
    case Text.EventLocation:
      return "Event location";
    case Text.FacilityOccupancy:
      return "Facility occupancy";
    case Text.ImportAndExportDetails:
      return "Import and export details";
    case Text.AdditionalFacilityInformation:
      return "Additional facility information";
    case Text.InventoryValue:
      return "Inventory value";
    case Text.Education:
      return "Education";
    case Text.Event:
      return "Event";
    case Text.Agent:
      return "Agent";
    case Text.DomesticallyAgreedFinancialStatementDetails:
      return "Domestically agreed financial statement details";
    case Text.OtherCurrentAssetDescription:
      return "Other current asset description";
    case Text.OtherCurrentLiabilityDescription:
      return "Other current liability description";
    case Text.FormerBusinessActivity:
      return "Former business activity";
    case Text.TradeNameUse:
      return "Trade name use";
    case Text.SigningAuthority:
      return "Signing authority";
    case Text.Guarantee:
      return "Guarantee";
    case Text.HoldingCompanyOperation:
      return "Holding company operation";
    case Text.ConsignmentRouting:
      return "Consignment routing";
    case Text.LetterProtest:
      return "Letter of protest";
    case Text.Question:
      return "Question";
    case Text.PartyInformation:
      return "Party information";
    case Text.AreaBoundariesDescription:
      return "Area boundaries description";
    case Text.AdvertisementInformation:
      return "Advertisement information";
    case Text.FinancialStatementDetails:
      return "Financial statement details";
    case Text.AccessInstructions:
      return "Access instructions";
    case Text.Liquidity:
      return "Liquidity";
    case Text.CreditLine:
      return "Credit line";
    case Text.WarrantyTerms:
      return "Warranty terms";
    case Text.DivisionDescription:
      return "Division description";
    case Text.ReportingInstruction:
      return "Reporting instruction";
    case Text.ExaminationResult:
      return "Examination result";
    case Text.LaboratoryResult:
      return "Laboratory result";
    case Text.AllowanceChargeInformation:
      return "Allowance/charge information";
    case Text.XRayResult:
      return "X-ray result";
    case Text.PathologyResult:
      return "Pathology result";
    case Text.InterventionDescription:
      return "Intervention description";
    case Text.SummaryAdmittance:
      return "Summary of admittance";
    case Text.MedicalTreatmentCourseDetail:
      return "Medical treatment course detail";
    case Text.Prognosis:
      return "Prognosis";
    case Text.InstructionToPatient:
      return "Instruction to patient";
    case Text.InstructionToPhysician:
      return "Instruction to physician";
    case Text.AllDocuments:
      return "All documents";
    case Text.MedicineTreatment:
      return "Medicine treatment";
    case Text.MedicineDosageAndAdministration:
      return "Medicine dosage and administration";
    case Text.AvailabilityPatient:
      return "Availability of patient";
    case Text.ReasonForServiceRequest:
      return "Reason for service request";
    case Text.PurposeService:
      return "Purpose of service";
    case Text.ArrivalConditions:
      return "Arrival conditions";
    case Text.ServiceRequestersComment:
      return "Service requester's comment";
    case Text.Authentication:
      return "Authentication";
    case Text.RequestedLocationDescription:
      return "Requested location description";
    case Text.MedicineAdministrationCondition:
      return "Medicine administration condition";
    case Text.PatientInformation:
      return "Patient information";
    case Text.PrecautionaryMeasure:
      return "Precautionary measure";
    case Text.ServiceCharacteristic:
      return "Service characteristic";
    case Text.PlannedEventComment:
      return "Planned event comment";
    case Text.ExpectedDelayComment:
      return "Expected delay comment";
    case Text.TransportRequirementsComment:
      return "Transport requirements comment";
    case Text.TemporaryApprovalCondition:
      return "Temporary approval condition";
    case Text.CustomsValuationInformation:
      return "Customs Valuation Information";
    case Text.ValueAddedTaxVatMarginScheme:
      return "Value Added Tax (VAT) margin scheme";
    case Text.MaritimeDeclarationHealth:
      return "Maritime Declaration of Health";
    case Text.PassengerBaggageInformation:
      return "Passenger baggage information";
    case Text.MaritimeDeclarationHealth_Dup:
      return "Maritime Declaration of Health";
    case Text.AdditionalProductInformationAddress:
      return "Additional product information address";
    case Text.InformationToBePrintedOnDespatchAdvice:
      return "Information to be printed on despatch advice";
    case Text.MissingGoodsRemarks:
      return "Missing goods remarks";
    case Text.NonAcceptanceInformation:
      return "Non-acceptance information";
    case Text.ReturnsInformation:
      return "Returns information";
    case Text.SubLineItemInformation:
      return "Sub-line item information";
    case Text.TestInformation:
      return "Test information";
    case Text.ExternalLink:
      return "External link";
    case Text.VatExemptionReason:
      return "VAT exemption reason";
    case Text.ProcessingInstructions:
      return "Processing Instructions";
    case Text.RelayInstructions:
      return "Relay Instructions";
    case Text.SimaApplicable:
      return "SIMA applicable";
    case Text.AppealsProgramCode:
      return "Appeals program code";
    case Text.SimaSubject:
      return "SIMA subject";
    case Text.SurtaxApplicable:
      return "Surtax applicable";
    case Text.SimaSecurityBond:
      return "SIMA security bond";
    case Text.SurtaxSubject:
      return "Surtax subject";
    case Text.SafeguardApplicable:
      return "Safeguard applicable";
    case Text.SafeguardApplicable_Dup:
      return "Safeguard applicable";
    case Text.SafeguardSubject:
      return "Safeguard subject";
    case Text.TransportContractDocumentClause:
      return "Transport contract document clause";
    case Text.InstructionToPreparePatient:
      return "Instruction to prepare the patient";
    case Text.MedicineTreatmentComment:
      return "Medicine treatment comment";
    case Text.ExaminationResultComment:
      return "Examination result comment";
    case Text.ServiceRequestComment:
      return "Service request comment";
    case Text.PrescriptionReason:
      return "Prescription reason";
    case Text.PrescriptionComment:
      return "Prescription comment";
    case Text.ClinicalInvestigationComment:
      return "Clinical investigation comment";
    case Text.MedicinalSpecificationComment:
      return "Medicinal specification comment";
    case Text.EconomicContributionComment:
      return "Economic contribution comment";
    case Text.StatusAPlan:
      return "Status of a plan";
    case Text.RandomSampleTestInformation:
      return "Random sample test information";
    case Text.PeriodTime:
      return "Period of time";
    case Text.Legislation:
      return "Legislation";
    case Text.SecurityMeasuresRequested:
      return "Security measures requested";
    case Text.TransportContractDocumentRemark:
      return "Transport contract document remark";
    case Text.PreviousPortCallSecurityInformation:
      return "Previous port of call security information";
    case Text.SecurityInformation:
      return "Security information";
    case Text.WasteInformation:
      return "Waste information";
    case Text.B2cMarketingInformationShortDescription:
      return "B2C marketing information, short description";
    case Text.B2bMarketingInformationLongDescription:
      return "B2B marketing information, long description";
    case Text.B2cMarketingInformationLongDescription:
      return "B2C marketing information, long description";
    case Text.ProductIngredients:
      return "Product ingredients";
    case Text.LocationShortName:
      return "Location short name";
    case Text.PackagingMaterialInformation:
      return "Packaging material information";
    case Text.FillerMaterialInformation:
      return "Filler material information";
    case Text.ShipToShipActivityInformation:
      return "Ship-to-ship activity information";
    case Text.PackageMaterialDescription:
      return "Package material description";
    case Text.ConsumerLevelPackageMarking:
      return "Consumer level package marking";
    case Text.SimaMeasureInForce:
      return "SIMA measure in force";
    case Text.PreCarm:
      return "Pre-CARM";
    case Text.SimaMeasureType:
      return "SIMA measure type";
    case Text.CustomsClearanceInstructions:
      return "Customs clearance instructions";
    case Text.SubTypeCode:
      return "Sub Type Code";
    case Text.SimaInformation:
      return "SIMA information";
    case Text.TimeLimitEnd:
      return "Time limit end";
    case Text.TimeLimitStart:
      return "Time limit start";
    case Text.WarehouseTimeLimit:
      return "Warehouse time limit";
    case Text.ValueForDutyInformation:
      return "Value for duty information";
    case Text.CustomsClearanceInstructionsExport:
      return "Customs clearance instructions export";
    case Text.ChangeInformation:
      return "Change information";
    case Text.CustomsClearanceInstructionImport:
      return "Customs clearance instruction import";
    case Text.ClearancePlaceRequested:
      return "Clearance place requested";
    case Text.LoadingRemarks:
      return "Loading remarks";
    case Text.OrderInformation:
      return "Order information";
    case Text.CustomerRemarks:
      return "Customer remarks";
    case Text.CustomsDeclarationInformation:
      return "Customs declaration information";
    case Text.DamageRemarks:
      return "Damage remarks";
    case Text.DocumentIssuerDeclaration:
      return "Document issuer declaration";
    case Text.DeliveryInformation:
      return "Delivery information";
    case Text.DeliveryInstructions:
      return "Delivery instructions";
    case Text.DocumentationInstructions:
      return "Documentation instructions";
    case Text.DutyDeclaration:
      return "Duty declaration";
    case Text.EffectiveUsedRouting:
      return "Effective used routing";
    case Text.FirstBlockToBePrintedOnTransportContract:
      return "First block to be printed on the transport contract";
    case Text.GovernmentBillLadingInformation:
      return "Government bill of lading information";
    case Text.EntireTransactionSet:
      return "Entire transaction set";
    case Text.FurtherInformationConcerningGgvsPar7:
      return "Further information concerning GGVS par. 7";
    case Text.ConsignmentHandlingInstruction:
      return "Consignment handling instruction";
    case Text.HazardInformation:
      return "Hazard information";
    case Text.ConsignmentInformationForConsignee:
      return "Consignment information for consignee";
    case Text.InsuranceInstructions:
      return "Insurance instructions";
    case Text.InvoiceMailingInstructions:
      return "Invoice mailing instructions";
    case Text.CommercialInvoiceItemDescription:
      return "Commercial invoice item description";
    case Text.InsuranceInformation:
      return "Insurance information";
    case Text.InvoiceInstruction:
      return "Invoice instruction";
    case Text.InformationForRailwayPurpose:
      return "Information for railway purpose";
    case Text.InlandTransportDetails:
      return "Inland transport details";
    case Text.TestingInstructions:
      return "Testing instructions";
    case Text.LocationAlias:
      return "Location Alias";
    case Text.LineItem:
      return "Line item";
    case Text.LoadingInstruction:
      return "Loading instruction";
    case Text.MiscellaneousChargeOrder:
      return "Miscellaneous charge order";
    case Text.MaritimeDeclarationHealth_Dup_Dup:
      return "Maritime Declaration of Health";
    case Text.AdditionalMarksNumbersInformation:
      return "Additional marks/numbers information";
    case Text.OrderInstruction:
      return "Order instruction";
    case Text.OtherServiceInformation:
      return "Other service information";
    case Text.PackingMarkingInformation:
      return "Packing/marking information";
    case Text.PaymentInstructionsInformation:
      return "Payment instructions information";
    case Text.PayablesInformation:
      return "Payables information";
    case Text.PackagingInformation:
      return "Packaging information";
    case Text.PackagingTermsInformation:
      return "Packaging terms information";
    case Text.PaymentDetailRemittanceInformation:
      return "Payment detail/remittance information";
    case Text.PaymentInformation:
      return "Payment information";
    case Text.ProductInformation:
      return "Product information";
    case Text.PriceCalculationFormula:
      return "Price calculation formula";
    case Text.PriorityInformation:
      return "Priority information";
    case Text.PurchasingInformation:
      return "Purchasing information";
    case Text.QuarantineInstructions:
      return "Quarantine instructions";
    case Text.QualityDemandsRequirements:
      return "Quality demands/requirements";
    case Text.QuotationInstructionInformation:
      return "Quotation instruction/information";
    case Text.RiskAndHandlingInformation:
      return "Risk and handling information";
    case Text.RegulatoryInformation:
      return "Regulatory information";
    case Text.ReturnToOriginInformation:
      return "Return to origin information";
    case Text.Receivables:
      return "Receivables";
    case Text.ConsignmentRoute:
      return "Consignment route";
    case Text.SafetyInformation:
      return "Safety information";
    case Text.ConsignmentDocumentaryInstruction:
      return "Consignment documentary instruction";
    case Text.SpecialInstructions:
      return "Special instructions";
    case Text.ShipLineRequested:
      return "Ship line requested";
    case Text.SpecialPermissionForTransportGenerally:
      return "Special permission for transport, generally";
    case Text.SpecialPermissionConcerningGoodsToBeTransported:
      return "Special permission concerning the goods to be transported";
    case Text.SpecialHandling:
      return "Special handling";
    case Text.SpecialPermissionConcerningPackage:
      return "Special permission concerning package";
    case Text.SpecialPermissionConcerningTransportMeans:
      return "Special permission concerning transport means";
    case Text.SubsidiaryRiskNumberIataDgr:
      return "Subsidiary risk number (IATA/DGR)";
    case Text.SpecialServiceRequest:
      return "Special service request";
    case Text.SupplierRemarks:
      return "Supplier remarks";
    case Text.ConsignmentTariff:
      return "Consignment tariff";
    case Text.ConsignmentTransport:
      return "Consignment transport";
    case Text.TransportationInformation:
      return "Transportation information";
    case Text.RequestedTariff:
      return "Requested tariff";
    case Text.TaxDeclaration:
      return "Tax declaration";
    case Text.WarehouseInstructionInformation:
      return "Warehouse instruction/information";
    case Text.MutuallyDefined:
      return "Mutually defined";
  }
}
